import {ICartBreakupItem} from 'models/OrderManagement'

const ALLOWED_CART_BREAKUP_KEYS = new Set([
 'sub_total',
 'discount',
 'gst',
])

const hasBreakupValue = (
 value: ICartBreakupItem['value']
) => value != null && String(value).trim() !== ''

export const getVisibleCartBreakup = (
 cartBreakup: ICartBreakupItem[]
) =>
 cartBreakup.filter((row) => {
  if (!ALLOWED_CART_BREAKUP_KEYS.has(row.key)) {
   return false
  }
  if (
   row.key === 'discount' &&
   !hasBreakupValue(row.value)
  ) {
   return false
  }
  return true
 })

export const getDiscountBreakup = (
 cartBreakup: ICartBreakupItem[]
) =>
 cartBreakup.find(
  (row) =>
   row.key === 'discount' && hasBreakupValue(row.value)
 )

export const getDisplayOrderTotal = (
 orderTotalBeforeDiscount?: number,
 orderTotal?: number
) => Number(orderTotalBeforeDiscount ?? orderTotal ?? 0)

export const getDisplayDiscountAmount = (
 discountAmount: number | undefined,
 discountBreakup?: ICartBreakupItem
) =>
 discountAmount ??
 (discountBreakup ? Number(discountBreakup.value) : 0)

export const getBreakupLabelKey = (
 row: ICartBreakupItem
): string | null => {
 if (row.key === 'sub_total') {
  return 'orderManagement.subTotalExcludingGst'
 }
 return null
}
